<template>
  <UApp :locale="locales[locale]">
    <router-view></router-view>
    <Notifications />
  </UApp>
</template>
<script setup>
import Notifications from "./components/base/Notifications.vue";
import * as locales from "@nuxt/ui/locale";

import { useI18n } from "vue-i18n";
const { locale } = useI18n();
</script>
